import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Section = styled.section<{ expanded?: boolean }>`
  display: flex;
  flex-direction: row;
  background: #fff;
  flex-wrap: wrap-reverse;
  ${breakpoint('md')`
    max-height: 895px;
    padding: 6em 0;
    flex-wrap: nowrap;
  `}
  ${breakpoint('sm', 'md')`
    max-height: 846px;
    padding: 5.5em 0;
    flex-wrap: nowrap;
  `}
  @media (min-width: 768px) and (max-width: 1720px) {
    margin-bottom: ${({ expanded }) => (expanded ? '190px' : '50px')};
  }
  @media (min-width: 1024px) and (max-width: 1057px) {
    margin-bottom: ${({ expanded }) => (expanded ? '300px' : '50px')};
  }
`;

const Content = styled.div`
  width: 53%;
  padding: 0 6rem;

  & > h2 {
    width: 70%;
    margin-top: 0;
    font-size: 36px;
    font-weight: 700;
  }
  & > p {
    width: 70%;
    font-size: 20px;
    font-weight: 400;
  }

  ${breakpoint('sm', 'md')`
    width: 68%;
    padding: 0 3.5em;
  `}

  ${breakpoint('xs', 'sm')`
    width: 100%;
    padding: 3.4em 1.5em;

    & > h2 {
      font-size: 28px;
    }

    & > p {
      font-size: 16px;
    }
  `}
`;

const AccordionItem = styled.div<{ expanded?: boolean }>`
  border-bottom: 2px solid #000000;
  cursor: pointer;
  & h3 {
    font-size: 20px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
  }
  & span {
    display: block;
    width: 70%;
    font-size: 14px;
    font-weight: 400;
  }

  .accordion-item-content {
    overflow: hidden;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: ${({ expanded }) => (expanded ? '300px' : '0')};
  }

  .action-icon {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ expanded }) => (expanded ? 'rotate(45deg)' : 'none')};
  }

  ${breakpoint('xs', 'sm')`
    width: 100%;

    & h3 {
      font-size: 18px;
      margin-top: 2rem;
    }
  `}
`;

const ImageContainer = styled.div`
  position: relative;
  width: 47%;

  img {
    object-fit: cover;
  }
  ${breakpoint('sm', 'md')`
    width: 32%;
  `}
  ${breakpoint('xs', 'sm')`
    width: 100%;
    height: 506px;
  `}
`;

const LinkInline = styled.span`
  color: ${theme('colors.orange')};
  text-transform: uppercase;
  font-weight: 700;
  text-decoration: none;
  font-size: 14px;
  margin: 1.5em 0;
  display: block;

  :hover {
    color: ${theme('colors.blue')};
    svg,
    path {
      fill: ${theme('colors.blue')};
      stroke: ${theme('colors.blue')};
    }
  }
`;

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export { Section, Content, AccordionItem, ImageContainer, LinkInline, VisuallyHidden };
